const STORAGE_KEY = "pendingCartChanges";

const getItemKey = (
  productId,
  productOptionId
) => {
  return `${productId}-${
    productOptionId ?? "without-option"
  }`;
};

export const getPendingCartChanges = () => {
  try {
    const value =
      localStorage.getItem(STORAGE_KEY);

    return value
      ? JSON.parse(value)
      : [];
  } catch (error) {
    console.error(
      "שגיאה בקריאת שינויי העגלה:",
      error
    );

    return [];
  }
};

const savePendingCartChanges = (
  changes
) => {
  localStorage.setItem(
    STORAGE_KEY,
    JSON.stringify(changes)
  );
};

/*
 * שמירת הכמות הסופית שהמשתמש רוצה.
 *
 * לדוגמה:
 * המוצר היה בכמות 2 והמשתמש שינה ל־4.
 * נשמור newAmount: 4 ולא "הוסף עוד 2".
 */
export const savePendingCartAmount = ({
  productId,
  productOptionId = null,
  amount,
}) => {
  const changes =
    getPendingCartChanges();

  const key = getItemKey(
    productId,
    productOptionId
  );

  const otherChanges =
    changes.filter(
      (item) =>
        getItemKey(
          item.productId,
          item.productOptionId
        ) !== key
    );

  otherChanges.push({
    type: "SET_AMOUNT",
    productId,
    productOptionId,
    amount: Number(amount),
  });

  savePendingCartChanges(
    otherChanges
  );
};

export const savePendingCartRemove = ({
  productId,
  productOptionId = null,
}) => {
  const changes =
    getPendingCartChanges();

  const key = getItemKey(
    productId,
    productOptionId
  );

  const otherChanges =
    changes.filter(
      (item) =>
        getItemKey(
          item.productId,
          item.productOptionId
        ) !== key
    );

  otherChanges.push({
    type: "REMOVE",
    productId,
    productOptionId,
  });

  savePendingCartChanges(
    otherChanges
  );
};

export const clearPendingCartChanges =
  () => {
    localStorage.removeItem(
      STORAGE_KEY
    );
  };